export const environment = {
	production: true,

	APP_ENV: 'staging',
	COMMIT_HASH: '6dde0337fc22dcbd0d7976b4c64e5cd86e3fb04f',
	API_URL: '/api/',
	SERVICE_SENTRY_DSN_PUBLIC: 'https://5ad80b7a4b734312baade3f0d7621365@sentry.io/221572',
};
